import type { CoordinateSystemSelection, RenameRequest } from '@visualizer/types';
import { requireApp } from 'store/assertions';

const getApiClient = () => requireApp().apiClient;

export async function rename(newLabel: string, item: RenameRequest): Promise<void> {
    await getApiClient().patch(`grids/${item.id}`, { name: newLabel });
}

export async function updateCoordinateReferenceSystem(gridId: string, selection: CoordinateSystemSelection): Promise<void> {
    const coordinateReferenceSystem =
        selection.mode === 'custom'
            ? {
                  rotation: selection.alpha,
                  point: {
                      x: selection.centerX,
                      y: selection.centerY,
                      z: selection.centerZ,
                  },
              }
            : {
                  rotation: 0,
                  point: {
                      x: 0,
                      y: 0,
                      z: 0,
                  },
              };

    // API to WRITE to the backend:
    await getApiClient().patch(`grids/${gridId}`, {
        params: {
            coordinateReferenceSystem,
        },
    });
}
